import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import avatar from '../../img/avatar.webp';
import { animateScroll as scroll } from 'react-scroll';
import 'animate.css';

export const Navigation = () => {
  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <NavigationStyled>
      <div className='avatar'>
        <img src={avatar} alt='perfil' />
      </div>
      <ul className='nav-items'>
        <li className='nav-item'>
          <NavLink
            to='/'
            onClick={toggleHome}
            activeClassName='active-class'
            exact
          >
            Home
          </NavLink>
        </li>
        <li className='nav-item'>
          <NavLink
            to='/about'
            onClick={toggleHome}
            activeClassName='active-class'
            exact
          >
            About
          </NavLink>
        </li>
        <li className='nav-item'>
          <NavLink
            to='/skills'
            onClick={toggleHome}
            activeClassName='active-class'
            exact
          >
            Skills
          </NavLink>
        </li>
        <li className='nav-item'>
          <NavLink
            to='/portfolio'
            onClick={toggleHome}
            activeClassName='active-class'
            exact
          >
            Portfolio
          </NavLink>
        </li>
        <li className='nav-item'>
          <NavLink
            to='/blog'
            onClick={toggleHome}
            activeClassName='active-class'
            exact
          >
            Blog
          </NavLink>
        </li>
        <li className='nav-item'>
          <NavLink
            to='/contact'
            onClick={toggleHome}
            activeClassName='active-class'
            exact
          >
            Contact
          </NavLink>
        </li>
      </ul>
      <footer className='footer'>
        <p>
          <b>J-M-Rodriguez</b> © 2026
        </p>
      </footer>
    </NavigationStyled>
  );
};

const NavigationStyled = styled.nav`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  /* border-right: 1px solid var(--border-color); */

  .avatar {
    width: 100%;
    text-align: center;
    padding-top: 2rem;

    img {
      width: 75%;
      border-radius: 0% 50%;
      // border: 2px solid var(--primary-color-light);
      box-shadow: 14px 16px 49px -14px rgba(0, 0, 0, 0.73);
      -webkit-box-shadow: 14px 16px 49px -14px rgba(0, 0, 0, 0.73);
      -moz-box-shadow: 14px 16px 49px -14px rgba(0, 0, 0, 0.73);
    }
  }
  .nav-items {
    width: 100%;
    text-align: center;
    .active-class {
      background-color: var(--primary-color-light);
      color: white;
    }
    li {
      display: block;
      a {
        display: block;
        padding: 0.45rem 0;
        position: relative;
        z-index: 10;
        text-transform: uppercase;
        transition: all 0.4s ease-in-out;
        font-weight: 600;
        letter-spacing: 1px;
        &:hover {
          cursor: pointer;
          color: var(--white-color);
        }
        &::before {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0;
          height: 50%;
          background-color: var(--primary-color);
          transition: All 0.4s cubic-bezier(1, -0.2, 0.25, 0.95);
          opacity: 0.21;
          z-index: -1;
        }
      }
      a:hover::before {
        width: 100%;
        height: 100%;
      }
    }
  }
  footer {
    width: 100%;
    p {
      padding: 1.3rem 0;
      font-size: 1.1rem;
      display: block;
      text-align: center;
    }
  }
`;
